import { useMemo } from 'react';

import type { MapProps, PinData } from '../../types';

/**
 * Returns a memoized not minimized pins.
 */
export const useNotMinimizedPins = (pins: MapProps['pins'] = []) => {
  return useMemo(() => pins.filter(checkIfPinIsNotMinimized), [pins]);
};

// ─── Utils ───────────────────────────────────────────────────────────────────

function checkIfPinIsNotMinimized(pin: PinData) {
  return !pin.isMinimized;
}
